import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/button';
import { ActionSheet } from '@components/scheduling/actionSheet';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { useIsPhone } from '@hooks/useIsPhone';
import { DiscardChangesProps } from './types';

export const DiscardChanges = ({ open, onKeep, onDiscard }: DiscardChangesProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'discardChanges' });
  const isPhone = useIsPhone();

  if (isPhone)
    return (
      <ActionSheet
        open={open}
        onDismiss={onKeep}
        title={t('title')}
        description={t('description')}
        actions={
          <div>
            <Button
              variant="secondary"
              className="border-danger-200 text-danger-600"
              onClick={onDiscard}>
              {t('discard')}
            </Button>
            <Button onClick={onKeep}>{t('keep')}</Button>
          </div>
        }
      />
    );

  return (
    <AlertDialog open={open} onOpenChange={(value) => !value && onKeep()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" className="text-danger-600" onClick={onDiscard}>
            {t('discard')}
          </Button>
          <Button onClick={onKeep}>{t('keep')}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
